import type { DriveUnitPortOccupancy } from '../redux/ApplicationSlice';

export const DRIVE_UNIT_PORT_MIN = 1;
export const DRIVE_UNIT_PORT_MAX = 8;

/** Framework `initialization.parameter` names for drive-unit ports (1–8). */
export const DRIVE_UNIT_PORT_PARAMETERS = {
  MOTOR: 'motor_port',
  SENSOR: 'sensor_port',
} as const;

export type DriveUnitPortParameterName = (typeof DRIVE_UNIT_PORT_PARAMETERS)[keyof typeof DRIVE_UNIT_PORT_PARAMETERS];

const PLAIN_INTEGER = /^[+-]?\d+$/;

export function isUnsupportedDriveUnitPortRawValue(rawValue: unknown): boolean {
  const rawText = String(rawValue ?? '').trim();
  if (!rawText) return false;
  return !PLAIN_INTEGER.test(rawText);
}

/**
 * Returns the lowest drive-unit port (1–8) not claimed in `rows`.
 * When every port is taken, returns `DRIVE_UNIT_PORT_MIN` so the UI can show a conflict state.
 */
export function getFirstUnusedDriveUnitPort(rows: ReadonlyArray<DriveUnitPortOccupancy>, options?: { excludeElectronic?: string }): number {
  const occupied = new Set<number>();
  for (const row of rows) {
    if (options?.excludeElectronic && row.electronic === options.excludeElectronic) continue;
    const port = row.driveUnitPort;
    if (port >= DRIVE_UNIT_PORT_MIN && port <= DRIVE_UNIT_PORT_MAX) {
      occupied.add(port);
    }
  }
  for (let port = DRIVE_UNIT_PORT_MIN; port <= DRIVE_UNIT_PORT_MAX; port++) {
    if (!occupied.has(port)) return port;
  }
  return DRIVE_UNIT_PORT_MIN;
}
